// 路由自动导入
// 利用webpack 的require.context自动导入
const req = require.context('./modules', false, /\.js$/)
let api = {}
req.keys().map((key) => {
	api = { ...api, ...req(key) }
})
export default api
